import { Container, Row, Col } from "react-bootstrap";
import Typewriter from "typewriter-effect";

const MainContent = () => {
  return (
    <div>
      <Container className="text-white justify-content-center align-items-center">
        <Row>
          <Col>
            <div className="title">
              <Typewriter
                options={{
                  strings: [
                    "im freeSpace, Front End Developer.",
                    "im freeSpace, UI & UX Designer.",
                  ],
                  autoStart: true,
                  loop: true,
                }}
                np
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default MainContent;
